import { render, staticRenderFns } from "./PollBlock.vue?vue&type=template&id=64032c25&scoped=true&"
import script from "./PollBlock.vue?vue&type=script&lang=js&"
export * from "./PollBlock.vue?vue&type=script&lang=js&"
import style0 from "./PollBlock.vue?vue&type=style&index=0&id=64032c25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64032c25",
  null
  
)

export default component.exports